<template>
  <div>
    <div class="banner" data-aos="zoom-out"><img :src="require('@/assets/img/about/position/news.jpg')" ></div>
    <div class="container">
      <about-menu @aboutSelect="aboutSelect"></about-menu>
       <div style="padding-left: 10%;margin-bottom: 100px">
         <div v-for="item in newsList" >
           <div class="card" @click="enterNew(item)">
             <div class="card-img">
               <img :src="item.src" width="100%" />
             </div>
             <div class="card-desc">
               <div class="desc">{{item.title}}</div>
               <div class="time">{{item.date}}</div>
             </div>
           </div>
         </div>
       </div>
    </div>
  </div>
</template>

<script>
import AboutMenu from "@/components/AboutMenu.vue";
import {newsInfoList} from "@/views/about/new/newsInfoList";
export default {
  name: "news",
  components: {AboutMenu},
  data(){
    return{
      showNesList:true,
      news:[],
      newsTitle:'',
      newsList:[
        {src:require('@/assets/news/9.jpg'),title:'聚焦精准医疗，共话创新未来！唐颐信息精彩亮相2025中国研究型医院学会临床数据与样本资源库专业委员会学术年会',date:'2025-11-06',key:'9'},
        {src:require('@/assets/news/8.jpg'),title:'唐颐信息AI产品精彩亮相福建生物样本学术盛会，赋能精准医疗新发展',date:'2025-09-09',key:'8'},
        {src:require('@/assets/news/7.png'),title:'《干细胞临床研究信息管理规范》团体标准发布，唐颐信息助力干细胞临床研究高质量发展',date:'2025-07-31',key:'7'},
        {src:require('@/assets/news/1.jpg'),title:'唐颐信息董事长唐万出席“2024中国研究型医院大会”',date:'2024-10-22',key:'1'},
        {src:require('@/assets/news/2.jpg'),title:'创新赋能，引领未来|唐颐信息精彩亮相第一届国际智能医学会议',date:'2024-10-21',key:'2'},
        {src:require('@/assets/news/3.png'),title:'圆满落幕!唐颐信息顺利参展2024中国研究型医院学会临床数据与样本资源库专业委员会学术年会',date:'2024-09-26',key:'3'},
        {src:require('@/assets/news/4.jpg'),title:'9月雄安，共襄盛会|2024中国研究型医院学会临床数据与样本资源库专业委员会学术大会',date:'2024-08-30',key:'4'},
        {src:require('@/assets/news/5.jpg'),title:'圆满落幕!第三届“专病数据库、样本库、知识库”临床三库建设与医学人工智能应用研讨会成功举办',date:'2024-06-02',key:'5'},
        {src:require('@/assets/news/6.jpg'),title:'唐颐信息协办|上海市生物信息学会2023年“大模型时代的生物信息学”学术年会圆满落幕',date:'2023-10-16',key:'6'},
      ]
    }
  },
  methods:{
    aboutSelect(src){
      this.$emit('aboutSelect',src)
    },
    showList(){
      this.showNesList=true
      document.documentElement.scrollTop=500
    },
    enterNew(data){
       let key =data.key
       this.$router.push({name:'newsItem',query:{key}})
       // let list =newsInfoList()
       //  if(list[key]){
       //    document.documentElement.scrollTop=500
       //    this.newsTitle=data.title
       //    this.news=list[key]
       //    this.showNesList=false
       //  }
    }
  }
}
</script>
<style scoped lang="less">
.banner{
  width: 100%;
}
.container{
  width: 100%;
  padding-left: 20%;
  box-sizing: border-box;
  position: relative;
}
.card{
  width: 1200px;
  display: flex;
  margin-top:40px ;
  border: 1px solid #d6d6d6;
  cursor: pointer;
}
.card-img{
  width:500px;
}
.card-desc{
  width: 700px;
  padding-top: 100px;
  padding-left: 40px;
}
.time{
  margin-top: 40px;
}
.info-card{
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 40px 0;
}
.info-desc{
  text-indent: 36px;
  text-align: justify;
}
</style>
